import 'css-chunksrc/feature/check-split/CheckSplitBySeat.module.scss';export default {
  "container": "CheckSplitBySeat_container",
  "table": "CheckSplitBySeat_table",
  "seat-button": "CheckSplitBySeat_seat-button",
  "selected": "CheckSplitBySeat_selected"
};